var module = angular.module('octopusApp.infrastructure')
    .run(ConfigureRedirects);

function ConfigureRedirects($rootScope, $location, $state, octopusAuthenticator, octopusLog, octopusClient, $uibModalStack) {

    // Some global properties for the current page
    $rootScope.isAuthenticated = octopusAuthenticator.currentUser() || false;
    $rootScope.currentUser = octopusAuthenticator.currentUser();
    $rootScope.redirectAfterFormsLoginTo = null;
    $rootScope.redirectAfterExternalLoginTo = octopusClient.uiRelativeRootPath($location);

    function stateRedirect(toState, toParams) {
        var redirect = toState.redirectTo;
        if (redirect) {
            if (angular.isFunction(redirect)) {
                redirect.call($state, toState, toParams);
            } else {
                $state.go(redirect);
            }
            return true;
        }
    }

    function subRouteRedirect(toState, toParams) {
        var redirect = toState.defaultSubRoute;
        if (redirect) {
            $state.go(redirect, toParams, {location: false});
            return true;
        }
    }

    $rootScope.$on('$stateChangeSuccess', function () {
        $rootScope.isAuthenticated = octopusAuthenticator.currentUser() || false;
        $rootScope.currentUser = octopusAuthenticator.currentUser();
        $uibModalStack.dismissAll();
    });

    // When the user changes navigation, make sure they are logged in
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        if (subRouteRedirect(toState, toParams)) {
            event.preventDefault();
            return;
        }

        if (stateRedirect(toState, toParams)) {
            event.preventDefault();
            return;
        }

        if (toState.name === 'app.not-found') {
            return;
        }

        if (octopusAuthenticator.currentUser() !== null) {
            $rootScope.redirectAfterFormsLoginTo = null;
            $rootScope.redirectAfterExternalLoginTo = null;
            return;
        }

        octopusLog.log('There is no current user.');
        if (isAnonymous(toState)) {
            // Preserve any pre-existing redirection so we follow deep links after signin or registration
            if ($rootScope.redirectAfterFormsLoginTo === null) {
                // The user refreshed on the signin or register page and we want to redirect to the dashboard afterwards
                setRedirection('/');
            }
            octopusLog.log('Sign-in or registration page is allowed, will return to ' + $rootScope.redirectAfterFormsLoginTo);
        } else {
            // This looks like the user has navigated to a deep link but isn't authenticated
            // We need to preserve the original intended route, and redirect to the signin page
            setRedirection($state.href(toState.name, toParams).replace('#', ''));

            octopusLog.log('Redirecting to the sign-in page, will return to ' + $rootScope.redirectAfterFormsLoginTo);
            event.preventDefault();
            $state.go('app.signin');
        }
    });

    function setRedirection(newPath) {
        var isDevelopmentMode = !octopusClient.urlIndicatesNonDevelopmentMode($location.absUrl(), octopusClient.resolve('~/'));
        var targetUrl = $location.absUrl().replace($location.path(), newPath);
        if($location.path() === '' || $location.path() === '/') {
            targetUrl =  $location.absUrl() + "/"+ newPath;
        }

        //In dev mode we want to just redirecto to abs path to accomidate the :9005 dev wrapper
        if (isDevelopmentMode) {
            $rootScope.redirectAfterExternalLoginTo = targetUrl;
        } else {
            // For local forms we will be staying within the SPA so can just redirect to path ...
            $rootScope.redirectAfterFormsLoginTo = newPath;
            // ... but for external redirects it needs to be a relative path.
            $rootScope.redirectAfterExternalLoginTo = octopusClient.urlStripHostAndPort(targetUrl);
        }
    }

    Octopus.Client.Util.ajax.beforeRequest = function () {
        // If we don't have an anti-forgery token we need to get one by logging in again
        if (octopusAuthenticator.currentUser() !== null && !Octopus.Client.Util.getAntiforgeryToken() && !isAnonymous($state.current)) {
            setRedirection($location.path());
            octopusLog.warn("The expected anti-forgery cookie is missing or has expired. Redirecting to login page, but will return to " + $rootScope.redirectAfterFormsLoginTo + ". See http://g.octopushq.com/CSRF for more details and troubleshooting.");
            octopusAuthenticator.logOut();
            return false;
        } else {
            return true;
        }
    };

    Octopus.Client.Util.ajax.error = function (error) {
        if (error.StatusCode === 401 && !isAnonymous($state.current)) {
            setRedirection($location.path());
            octopusLog.log("Session Auth Cookie has expired or is missing. Redirecting to login page, but will return to " + $rootScope.redirectAfterFormsLoginTo);
            octopusAuthenticator.logOut();
        }
    };
}

function isAnonymous(stateName) {
    return (stateName.name.indexOf('app.register') === 0 || stateName.name === 'app.signin');
}


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/configuration/authentication.js
// module id = 5558476434999924
// module chunks = 1